import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { FaMapMarkerAlt } from 'react-icons/fa';

const GOOGLE_API_KEY = 'AIzaSyAHQSuklfkVa-mATYvbA7odk3_LpnKG-OA';

const mapContainerStyle = {
    width: '100%',
    height: '100%'
};

const LocationViewer = ({ lat, lng, height = '300px', title = '' }) => {
    const [map, setMap] = useState(null);

    // الموقع الافتراضي (القاهرة، مصر)
    const defaultCenter = useMemo(() => ({ 
        lat: 30.0444, 
        lng: 31.2357 
    }), []);

    const position = useMemo(() => {
        if (lat && lng && !isNaN(parseFloat(lat)) && !isNaN(parseFloat(lng))) {
            return {
                lat: parseFloat(lat),
                lng: parseFloat(lng)
            };
        }
        return null;
    }, [lat, lng]);

    const center = useMemo(() => 
        position || defaultCenter, 
        [position, defaultCenter]
    );

    const handleLoad = useCallback((map) => {
        setMap(map);
    }, []);

    const mapOptions = useMemo(() => ({
        disableDefaultUI: false,
        zoomControl: true,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: true,
        language: 'ar',
        region: 'EG',
        draggable: true,
        scrollwheel: true,
        disableDoubleClickZoom: false,
    }), []);

    if (!position) {
        return (
            <div style={{ 
                border: '2px dashed #dee2e6', 
                borderRadius: '12px', 
                height,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f8f9fa'
            }}>
                <div className="text-center text-muted">
                    <FaMapMarkerAlt style={{ fontSize: '3rem', marginBottom: '1rem' }} />
                    <p className="mb-0">لا يوجد موقع محدد</p>
                </div>
            </div>
        );
    }

    return (
        <div style={{ 
            border: '2px solid #e9ecef', 
            borderRadius: '12px', 
            overflow: 'hidden',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            position: 'relative'
        }}>
            <LoadScript
                googleMapsApiKey={GOOGLE_API_KEY}
                language="ar"
                region="EG"
            >
                <div style={{ height }}>
                    {title && (
                        <div style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            zIndex: 1000,
                            backgroundColor: 'rgba(255, 255, 255, 0.95)',
                            padding: '8px 16px',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: '600',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            direction: 'rtl'
                        }}>
                            📍 {title}
                        </div>
                    )}

                    <GoogleMap
                        mapContainerStyle={mapContainerStyle}
                        center={center}
                        zoom={18}
                        onLoad={handleLoad}
                        options={mapOptions}
                    >
                        <Marker position={position} />
                    </GoogleMap>
                </div>
            </LoadScript>
            
            {/* Display coordinates */}
            <div style={{
                position: 'absolute',
                bottom: '10px',
                left: '50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: '600',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                zIndex: 1000,
                direction: 'rtl'
            }}>
                📍 {parseFloat(lat).toFixed(7)}, {parseFloat(lng).toFixed(7)}
            </div>
        </div>
    );
};

LocationViewer.displayName = 'LocationViewer';

export default React.memo(LocationViewer);

